import React, {useEffect, useState} from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {LanguageService} from "../../language/LanguageService";
import {ICommunityFilterItem, ISsqDataDocument, SsqDataRepository,} from "../../repositories/SsqDataRepository";
import {DocType} from "definitions/DocType";
import {SsqImages} from "images/SsqImages";
import {TitleBarContainer, TitleBarContents, TitleBarItem, ViewmoreArea} from "style/CommonStyledComponents";
import MobileFooter from "communitypage/common/MobileFooter";
import {BLOG_DOC_TYPE, CommunityFilter, PERIOD_TYPE, PRODUCT_TYPE, SORT_TYPE,} from "../common/CommunityFilter";
import AsidePanel from "communitypage/common/AsidePanel";
import styled from "styled-components";
import SwiperCore, {Mousewheel, Navigation, Scrollbar} from "swiper";
import {AccountService} from "repositories/AccountService";
import {CategoryRepository, ICategory} from "repositories/category/CategoryRepository";
import {fontFamilyBold, fontFamilyMedium, fontFamilyRegular} from "style/fonts";
import {IfLoginInfo} from "models/IfLoginInfo";
import {connect} from "react-redux";
import {ACTION_TYPES} from "store/ActionTypes";
import useLoading from "hooks/useLoading";
import BlogDocumentListItem from "communitypage/blog/BlogDocumentListItem";
import {isEqual} from "lodash-es";
import {langutil} from "language/langutil";
import {loginutil} from "util/loginutil";
import {tcommona} from "language/i18nkey";
import {getLangSuffix, HelmetTitleAndH1} from "ctls/common/HelmetTitleAndH1";
import {IfDocCommentInfo} from "models/IfSsqDataDocCommentEntity";
import {useIsLogin} from "hooks/useIsLogin";
import {roleutil} from "util/roleutil";

interface ICommunityPageMatchParams {
  subMenu: string;
  country?: string;
  lang?: string;
}

interface Props extends RouteComponentProps<ICommunityPageMatchParams> {
  languageService: LanguageService;
  ssqDataRepository: SsqDataRepository;
  accountService: AccountService;
  categoryRepository: CategoryRepository;
  loginInfo: IfLoginInfo;

  displayLoginPopup: Function;
}

interface ISrchParam {
  sortType: string;
  blogDocType: string;
  prodType: ICategory;
  periodType: string;
  tagType: string[];
  keyword: string;
}


export const BlogPage = (props: Props) => {
  const [documentListComment, setDocumentListComment] = useState([] as Array<IfDocCommentInfo>);

  const [viewMoreState, setViewMoreState] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [srchParam, setSrchParam] = useState<ISrchParam>({
    sortType: SORT_TYPE.UPDATE,
    blogDocType: BLOG_DOC_TYPE.DEFAULT,
    prodType: PRODUCT_TYPE.DEFAULT,
    periodType: PERIOD_TYPE.DEFAULT,
    tagType: [],
    keyword: ''
  });

  const [documentList, setDocumentList] = useState([] as ISsqDataDocument[]);
  const [documentCount, setDocumentCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  const [isMounted, setIsMounted] = useState(false);

  const [clickedTag, setClickedTag] = useState('');

  const [keyword, setKeyword] = useState('');

  const [resetFilter, setResetFilter] = useState(false);

  const setLoading = useLoading();

  const isLogin = useIsLogin();

  const {country, lang} = langutil.splitLangCode(props.languageService.lang());

  const [isPartners, setIsPartners] = useState<boolean | null>(null);

  const defaultFilterData: ICommunityFilterItem = {
    sortType: 0,
    docTypes: [DocType.APPLICATION_NOTE, DocType.TECHNICAL_GUIDE, DocType.TECH_GENERAL],
    categoryId: 0,
    finish: "",
    period: 0,
    siteLanguage: props.languageService.getLanguage(),
    tags: [],
    pageNum: 0,
    keyword: '',
    isEmploy: false,
    isPartner: isPartners
  };

  useEffect(() => {
    if (window.innerWidth < 1199)
      setIsMobile(true);
    else
      setIsMobile(false);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setClickedTag('');
  }, [clickedTag]);

  useEffect(() => {
    if (loginutil.isnotlogin(props.loginInfo)) {
      return;
    }

    roleutil.hasPartnerChecks(props.loginInfo.userId, props.languageService.getLanguage())
      .then((res) => {
        setIsPartners(res);
        return requestFilter(res); // 현재의 isPartners 값을 전달
      })
      .catch((error) => {
        setIsPartners(false);
        return requestFilter(false); // 오류 발생 시 false 전달
      });
  }, [props.loginInfo.userId, props.languageService]);

  async function requestFilter(isPartners) {
    await setPageCount(0);
    const loginType = props.loginInfo?.loginType;
    const filteredData = {
      sortType: srchParam.sortType === SORT_TYPE.RECENT ? 0 : srchParam.sortType === SORT_TYPE.UPDATE ? 1 : 2,
      docTypes: srchParam.blogDocType === BLOG_DOC_TYPE.DEFAULT ? defaultFilterData.docTypes : [srchParam.blogDocType],
      categoryId: srchParam.prodType.id,
      period: srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 : srchParam.periodType === PERIOD_TYPE.WEEK ? 1 : srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 : srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
      siteLanguage: props.languageService.getLanguage(),
      pageNum: 0,
      tags: srchParam.tagType,
      finish: '',
      keyword: srchParam.keyword,
      isEmploy: loginType === "WELS",
      isPartner: isPartners
    };
    const docData = await props.ssqDataRepository.getSsqDataByFilter(filteredData);
    const docCount = await props.ssqDataRepository.getCountOfSsqDataByFilter(filteredData);
    setDocumentCount(docCount);
    setDocumentList(docData);
    setIsMounted(true);
  }

  async function requestFilterPage(isPartners) {
    const loginType = props.loginInfo?.loginType;

    const filteredData = {
      sortType: srchParam.sortType === SORT_TYPE.RECENT ? 0 : srchParam.sortType === SORT_TYPE.UPDATE ? 1 : 2,
      docTypes: srchParam.blogDocType === BLOG_DOC_TYPE.DEFAULT ? defaultFilterData.docTypes : [srchParam.blogDocType],
      categoryId: srchParam.prodType.id,
      period: srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 : srchParam.periodType === PERIOD_TYPE.WEEK ? 1 : srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 : srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
      siteLanguage: props.languageService.getLanguage(),
      finish: '',
      tags: srchParam.tagType,
      pageNum: pageCount,
      keyword: srchParam.keyword,
      isEmploy: loginType === "WELS",
      isPartner: isPartners
    };
    const docData = await props.ssqDataRepository.getSsqDataByFilter(filteredData);
    setDocumentList(documentList.concat(docData));
  }


  /*pageNum:0*/
  useEffect(() => {
    requestFilter(isPartners).finally(() => setLoading(false));
  }, [srchParam]);

  /*pageNum:count*/
  useEffect(() => {
    if (pageCount !== 0) requestFilterPage(isPartners).finally(() => setViewMoreState(false));
  }, [pageCount]);

  /*글쓰기 로그인*/
  const onPostClick = () => {
    isLogin ?
      window.open(`/${country}/${lang}/community/new/0?docgrp=blog`)
      :
      props.displayLoginPopup();
  };

  /*언어 설정*/
  const getTranslation = (key: string) => {
    props.languageService.setNamespace("I18N_NAMESPACE_COMMUNITY_PAGE");
    return props.languageService.getTranslationByKey(key) || "";
  };

  /*문서 없을 시 나오는 이미지 페이지*/
  const renderNoDocumentPage = () => {
    return <ErrorpageWrapBlog className={"ErrorpageWrapBlog"}>

      <div className={"Errorpage_blog"}>
        <img className={"error-image"} alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>

        {
          !isEqual(srchParam, {
            sortType: SORT_TYPE.UPDATE,
            blogDocType: BLOG_DOC_TYPE.DEFAULT,
            prodType: PRODUCT_TYPE.DEFAULT,
            periodType: PERIOD_TYPE.DEFAULT,
            tagType: [],
            keyword: ''
          }) &&

          <button className="error-button" onClick={() => {
            setResetFilter(!resetFilter);
          }}>
            {getTranslation("I18N_COMMUNITY_SEARCH_RESET")}
          </button>
        }
      </div>

    </ErrorpageWrapBlog>;
  };


  // 헤더 그림 표시
  const renderBlogHeaderContents = () => {
    const showWriteBtn = () => {
      if (props.loginInfo.allowExpert) return true;
      if (loginutil.islse(props.loginInfo)) return true;
      return false;
    };
    return <>
      <div className="community__header">
        <div className="visual-item">
          <div className="bg-human"></div>
          <div className="bg-qna"></div>
        </div>
        <div className="visual-text">
          <p className="v-txt-lg">{getTranslation("I18N_TITLE_COMMUNITY_BLOG")}</p>
          <p className="v-txt-sm">{getTranslation("I18N_TITLE_COMMUNITY_BLOG_TEXT01")}</p>
          {showWriteBtn() &&
            <button className="btn-box btn-write" onClick={onPostClick}>{getTranslation("I18N_TITLE_COMMUNITY_COMMON_HEADER_WRITE_BUTTON")}</button>}
        </div>
      </div>
    </>;
  };

  // 하단 더보기 버튼
  const renderBlogViewMoreButton = () => {
    return (
      <ViewmoreArea>
        <div className="view-more-list-box">
          <div className="ViewmoreBtn">
            <button className="view-more-button" onClick={(e) => {
              if (!viewMoreState) {
                setViewMoreState(true);
                setPageCount(pageCount + 1);
              }
            }}>{getTranslation("I18N_DOC_VIEW_MORE")}
            </button>
          </div>
          <div className="ViewmoreNum">
            <span className="page-count">{documentList.length}</span>
            <span> {documentCount}</span>
          </div>
        </div>
      </ViewmoreArea>
    );
  };

  SwiperCore.use([Navigation, Mousewheel, Scrollbar]);

  return (<>
    <HelmetTitleAndH1 title={tcommona('I18N_COMMON_TIT_TECHLOG', [], [getLangSuffix()])}/>
    <BlogContainer aria-label={"Blog-page"}>
      <TitleBarContainer>
        <TitleBarContents className={"container"}>
          <TitleBarItem><a href={`/${country}/${lang}/main`}>{getTranslation("I18N_TITLE_MAIN")}</a></TitleBarItem>
          <TitleBarItem>{getTranslation("I18N_TITLE_COMMUNITY")}</TitleBarItem>
          <TitleBarItem className="selected">{getTranslation("I18N_TITLE_COMMUNITY_BLOG")}</TitleBarItem>
        </TitleBarContents>
      </TitleBarContainer>
      <section className="community-body">
        <div className={"wrapper container sub-container"}>

          {/*상단 책, 사람 이미지 및 글쓰기버튼 구간*/}
          {renderBlogHeaderContents()}

          {/*필터 부분*/}
          <CommunityFilter page={'blog'}
            setSrchParam={setSrchParam}
            languageService={props.languageService}
            categoryRepository={props.categoryRepository}
            outerClickedTag={clickedTag}
            reset={resetFilter}
          />

          <div className="community__content">
            <div className="content" style={{paddingBottom: '3.2rem'}}>
              <ul className="community-item">
                {/*  문서 불러오는 부분*/}
                {documentList.length > 0 ? documentList.map((document) => {
                    return (<BlogDocumentListItem
                      commentList={documentListComment}
                      displayLoginPopup={props.displayLoginPopup}
                      key={document.id}
                      clickedTag={setClickedTag}
                      languageService={props.languageService}
                      ssqDocument={document}
                      getTranslation={getTranslation}
                      accountService={props.accountService}/>);
                  })
                  :
                  isMounted && renderNoDocumentPage()
                }
              </ul>
              {/* 더보기*/}
              {documentList.length !== documentCount && renderBlogViewMoreButton()}
            </div>

            {/* 오른쪽 사이드*/}
            <AsidePanel clickedTag={setClickedTag} getTranslation={getTranslation} page={"BLOG"} displayLoginPopup={props.displayLoginPopup}/>
          </div>

        </div>
      </section>
      <MobileFooterContainer>
        <MobileFooter
          languageService={props.languageService}
          getTranslation={getTranslation}
          displayLoginPopup={props.displayLoginPopup}
          accountService={props.accountService}
        >
        </MobileFooter>
      </MobileFooterContainer>
    </BlogContainer>
  </>);


};


/* 하단 푸터 스크립트 시작 */

/*const commFooterMenu = document.querySelector('.commonity-footer-menu');

let lastScrollY = 0;
console.log("direction");
addEventListener("scroll", e => {
  const scrollY = window.scrollY;
  // 이전의 스크롤 위치와 비교하기
  const direction = scrollY > lastScrollY ? footerActive() : footerRemove();
  // 현재의 스크롤 값을 저장
  lastScrollY = scrollY;
});

function footerActive() {
  commFooterMenu.classList.add('active');
}

function footerRemove() {
  commFooterMenu.classList.remove('active');
}*/

/* 하단 푸터 스크립트 끝 */


//export default withRouter(BlogPage);

export default withRouter(connect(
  (state: any) => ({
    loginInfo: state.main.loginInfo,
  }),

  dispatch => ({
    setLoginInfo: (info: IfLoginInfo) => dispatch({type: ACTION_TYPES.MAIN.LOGIN_INFO, payload: info}),
  })
)(BlogPage));


export const BlogContainer = styled.div`

  //내용 제목 임직원 타이틀 위치

  .lv-info {
    display: inline-block;
    background: #7783A1;
    color: #fff;
    border-radius: 16px;
    //width: 4.8rem;
    padding: 0 0.8rem;
    height: 1.8rem;
    line-height: 1.8rem;
    font-size: 9px;
    //font-weight: bold;
    text-align: center;
    vertical-align: middle;
    margin-left: .6rem;

  }

  .partner-level {
    display: inline-block;
    background: #F4B209;
    color: rgb(255, 255, 255);
    border-radius: 16px;
    //width: 4.8rem;
    padding: 0 0.8rem;
    height: 1.8rem;
    line-height: 1.8rem;
    font-size: 9px;
    //font-weight: bold;
    text-align: center;
    vertical-align: middle;
    margin-left: .6rem;
  }

  //내용 제목 임직원 타이틀 색상

  .lv-worker {
    background: #7783A1 !important;
    color: #fff !important;
  }

  //전체 화면 색

  section.community-body {
    background: #EEF1F6;
    position: relative;
    top: 0rem;
    min-height: calc(100% - 60px);
  }

  section.community-body.border-top-1 {
    border-top: .1rem solid #C7D6EA;
  }

  //나오는 부분 시작화면

  .sub-container {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  }

  //내용화면

  .community__content {
    display: flex;
    background: #F7F8FB;
  }

  //사이드

  .community__content > aside {
    width: 24rem;
    padding-top: 3.2rem;
  }

  //내용 속 디테일 내용

  .community__content > .content {
    padding: 3.2rem 3.2rem 0;
    width: calc(100% - 24rem);
  }

  //제목,사람, 책 사진부분

  .community__header {
    background: #fff;
    color: #fff;
    padding: 4rem 4rem 2.4rem 4rem;
    position: relative;
  }

  //select부분

  .community-item > li {
    margin-top: 2.4rem;
    width: 100%;
  }

  .community-item > li:first-child {
    margin-top: 0;
  }

  //하늘색부분

  .visual-item {
    height: 20rem;
    background: #ECF2FB;
    border-radius: 48px;
    width: 100%;
    position: relative;
    margin: 0 0.8rem;
  }

  //사람 사진

  .visual-item .bg-human {
    width: 20rem;
    height: 28rem;
    background-image: url(${SsqImages.community.visualBlogPerson()});
    background-repeat: no-repeat;
    background-size: 20rem 28rem;
    position: absolute;
    top: -4rem;
    right: 10rem;
  }

  //책사진

  .visual-item .bg-qna {
    width: 10rem;
    height: 10rem;
    background-image: url(${SsqImages.community.visualBlogBook()});
    background-repeat: no-repeat;
    position: absolute;
    top: 5rem;
    right: 32rem;
  }

  //글자들

  .visual-text {
    position: absolute;
    top: 8rem;
    left: 10.4rem;
    color: #2A2C2F;
  }

  .visual-text > p.v-txt-lg {
    font-size: 2.4rem;
    line-height: 3.6rem;
  }

  .visual-text > p.v-txt-sm {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.1rem;
  }

  //글쓰기 버튼 상자

  .btn-box {
    width: 13.2rem;
    height: 4.8rem;
    border-radius: .4rem;
    font-size: 1.6rem;
    ${fontFamilyBold};
  }

  //버튼 색상

  .btn-box.btn-write {
    background: #407EDB;
    color: #fff;
    margin-top: 1.6rem;
  }

  //내용 박스

  .community-item > li {
    display: flex;
    background: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
  }
}

//내용 박스 하나하나
.community-item > li .write-body {
  width: 100%;
  max-width: calc(100% - 16rem);
  padding: 1.5rem 3.2rem 1.8rem 3.2rem;
  //margin-right: 3.2rem;
  cursor: pointer;
}

@media screen and (max-width: 764px) {
  .community-item > li .write-body {
    width: 100%;
    max-width: 100% !important;
  }
}

//내용박스 속 젤 앞 태그
.community-item > li .tag {
  padding: .3rem 0;
}

//내용박스 속 두번째 태그 부분
.community-item > li .tag span {
  color: #407DD8;
  font-size: 1.3rem;
  ${fontFamilyRegular};
  margin-right: 1rem;
  font-weight: 500;
  line-height: 1.8;
  cursor: pointer;
  display: inline-block;
}

.community-item > li .tag span:hover {
  color: #25426D;
}

.community-item > li .tag span.post-kind {
  color: #7783A1;
}

//내용 사진
.community-item > li .blog-img {
  width: 16rem;
  min-height: 16rem;
  flex-shrink: 0;
  border-radius: 0 0.4rem 0.4rem 0;
}

// 내용제목
.community-item .blog-title p.write-title {
  .search_highlight {
    background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
  }

  color: #2A2C2F;
  font-size: 1.8rem;
  ${fontFamilyBold};
  line-height: 2.6rem;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 1rem;
}

//내용
.community-item > li p.write-content {
  .search_highlight {
    background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
  }

  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  color: #2A2C2F;
  font-size: 1.3rem;
  ${fontFamilyRegular};
  line-height: 1.8rem;
  margin-top: 0.5rem;
  width: 100%;
  text-overflow: clip;
  overflow: hidden;
  cursor: pointer;
}

//모바일 버전 이미지
.community-item .blog-content .blog-mobile-img {
  display: none;
}


//키워드 검색


.mobile-black {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  background: rgba(0, 0, 0, .5);
  display: none;
}

/*내용 속 하단의 임직원, 시간, 조회수 등*/

div.comment-wrap {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;
  align-items: center;
}

div.comment-wrap > li {
  margin-right: 1rem;
  font-size: 1.2rem;
  ${fontFamilyRegular};
  color: #7783A1;
  font-weight: 500;
  line-height: 2.4;
}

div.comment-wrap .c-txt {
  ${fontFamilyMedium};
  height: 1.8rem;
  line-height: 1.8rem;
  padding: 0 1rem;
  font-size: 1rem;
  border-radius: 2rem;
  margin-right: 0.4rem;
}

/*모바일 버전 하단 footer 메뉴*/

.commonity-footer-menu {
  display: none;
}

.inquiry-box .inquiry-list {
  display: flex;
}

/*---------- 타블렛 사이즈 ----------*/

@media (min-width: 765px) and (max-width: 1199px) {
  aside.community-aside {
    padding-right: 3.2rem;
    flex-wrap: wrap;
    display: flex;

    > div {
      width: 33%;
    }

    > div:first-child {
      width: 100%;
      justify-content: center;
    }
  }


  .visual-item .bg-qna {
    display: none;
  }

  .visual-item .bg-human {
    background-image: url("${SsqImages.community.visualBlogPerson()}");
    background-repeat: no-repeat;
    background-position: 5rem center;
    top: -4rem;
    right: -3rem;
  }

  .community__content {
    display: flex;
    flex-wrap: wrap;
  }

  .community__content > aside {
    width: 100%;
    padding: 3.2rem;
    padding-top: 2.4rem;
  }

  .best-item {
    display: flex;
  }

  .best-item > div {
    //width: 33%;
    margin-top: 2rem;
  }

  .best-item .tag-best {
    padding-right: 3rem;
  }

  .tag-best-mem .best-men-item {
    margin-top: 0.8rem;
  }

  .tag-best-qna > ul > li {
    padding: 0.5rem 0;
  }

  .tag-best-qna .best-content {
    width: auto;
  }

  .community__content > .content {
    padding: 3.2rem;
    padding-bottom: 0;
    width: 100%;
  }

  .community-item > li p.write-content {
    width: 100%;
    text-overflow: clip;
    white-space: normal;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

}

/*---------- 모바일 사이즈 ----------*/

@media screen and (max-width: 764px) {

  aside.community-aside {
    padding-right: 0;
  }

  .btn-filter {
    display: block;
    margin-right: 1.6rem;
  }

  .community__content {
    display: flex;
    flex-direction: column;
    background-color: #fff;
  }


  .community__header {
    padding: 0;
  }

  .visual-item {
    height: 30rem;
    border-radius: 0;
    width: 100%;
    margin: 0;
  }

  .visual-item .bg-human {
    width: 10rem;
    height: 14rem;
    background-size: cover;
    position: absolute;
    top: 15rem;
    right: 4rem;
  }

  .visual-item .bg-qna {
    width: 10rem;
    height: 10rem;
    position: absolute;
    top: 5rem;
    right: 32rem;
    display: none;
  }

  .visual-text {
    position: absolute;
    height: 100%;
    width: 100%;
    padding: 0 4rem;
    top: 4rem;
    left: 0;
    bottom: 0;
  }

  .visual-text > p.v-txt-lg {
    font-size: 2.4rem;
    line-height: 3.6rem;
  }

  .visual-text > p.v-txt-sm {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.1rem;
    margin-top: 1.2rem;
  }

  .btn-box.btn-write {
    position: absolute;
    top: 16rem;
  }

  aside.community-aside {
    display: none;
  }

  .community__content > .content {
    padding: 0;
    width: 100%;
  }

  .community-item {
    width: 100%;
  }

  .community-item > li {
    box-shadow: none;
    margin-top: 0;
    width: 100%;
  }

  .community-item > li .write-body {
    width: 100%;
    padding: 1.5rem 1.6rem;
    margin-right: 0;
    border-top: 1px solid #EEF1F6;
    box-sizing: border-box;
  }

  .community-item > li:first-child .write-body {
    border: none;
  }

  .community-item > li .tag {
    padding: .3rem 0;
  }

  .community-item > li .tag span {
    color: #407DD8;
    font-size: 1.3rem;
    margin-right: 1.2rem;
    font-weight: 500;
  }

  .community-item > li .blog-img {
    display: none;
  }

  .community-item .blog-title p.write-title {
    color: #2A2C2F;
    font-size: 1.8rem;
    line-height: 2.8rem;
    width: 100%;
    text-overflow: clip;
    white-space: normal;
    overflow: inherit;
    margin-top: 1rem;
  }

  .community-item > li p.write-content {
    width: 100%;
    text-overflow: clip;
    white-space: normal;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 0;
    word-break: break-all;
  }

  .community-item .blog-content {
    display: flex;
    margin-top: 0.5rem;
  }

  .community-item .blog-content .blog-content-item {
    width: 100%;
  }

  .community-item .blog-content .blog-mobile-img {
    display: block;
    width: 9rem;
    height: 9rem;
    background: #F6F8FB;
    border: 1px solid #EEF1F5;
    border-radius: .4rem;
    position: relative;
    flex-shrink: 0;
    margin-right: 1rem;
  }

  .community-item .blog-content .blog-mobile-img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }


  div.comment-wrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: .5rem;
  }

}

`;


/*모바일 버전 시 하단 footer*/
export const MobileFooterContainer = styled.div`

  //한글 페이지

  .commonity-footer-menu {
    display: none;
  }

  //영어 사이트

  .commonity-footer-menu-en {
    display: none;
  }

  @media screen and (max-width: 764px) {

    //한글 사이트
    .commonity-footer-menu {
      display: block;
      width: 100%;
      height: 6.4rem;
      background: #fff;
      position: fixed;
      bottom: -6.4rem;
      z-index: 99;
      border-top: 1px solid #C7D6EA;
      transition: bottom .4s;
    }

    //영어 사이트
    .commonity-footer-menu-en {
      display: block;
      width: 100%;
      height: 6.4rem;
      background: #fff;
      position: fixed;
      bottom: -6.4rem;
      z-index: 99;
      border-top: 1px solid #C7D6EA;
      transition: bottom .4s;
    }

    //한글 사이트
    .commonity-footer-menu.active {
      bottom: 0;
      transition: bottom .4s;
    }

    .commonity-footer-menu ul {
      display: flex;
    }

    .commonity-footer-menu ul li {
      width: 20%;
      text-align: center;
    }

    .commonity-footer-menu ul li button.c-footer {
      width: 100%;
      height: 6.4rem;
    }

    //한글-끝
    //영어사이트
    .commonity-footer-menu-en.active {
      bottom: 0;
      transition: bottom .4s;
    }

    .commonity-footer-menu-en ul {
      display: flex;
    }

    .commonity-footer-menu-en ul li {
      width: 25%;
      text-align: center;
    }

    .commonity-footer-menu-en ul li button.c-footer {
      width: 100%;
      height: 6.4rem;
    }

    //영어-끝
    button.c-footer span.name {
      display: none;
      font-weight: 500;
      font-size: 1rem;
      ${fontFamilyMedium};
      line-height: 12px;
      padding: .3rem 0;
    }

    button.c-footer > .icon {
      width: 28px;
      height: 28px;
      display: block;
      margin: auto;
    }

    button.c-footer.qna.on img.icon {
      filter: invert(53%) sepia(70%) saturate(369%) hue-rotate(123deg) brightness(91%) contrast(90%);
    }

    button.c-footer.qna.on span.name {
      color: #34A597;
      display: block;
    }

    button.c-footer.blog.on img.icon {
      filter: invert(49%) sepia(22%) saturate(1812%) hue-rotate(179deg) brightness(90%) contrast(89%);
    }

    button.c-footer.blog.on span.name {
      color: #407EDB;
      display: block;
    }

    button.c-footer.info.on img.icon {
      filter: invert(50%) sepia(34%) saturate(3185%) hue-rotate(218deg) brightness(88%) contrast(93%);
    }

    button.c-footer.info.on span.name {
      color: #756CD9;
      display: block;
    }

    button.c-footer.sample.on img.icon {
      filter: invert(49%) sepia(22%) saturate(1812%) hue-rotate(179deg) brightness(90%) contrast(89%);
    }

    button.c-footer.sample.on span.name {
      color: #407EDB;
      display: block;
    }

    button.c-footer.write > .icon {
      background: url(${SsqImages.community.communityFooterWrite()}) no-repeat center;
    }

    button.c-footer.write.on > .icon {
      background: url(${SsqImages.community.communityFooterWriteOn()}) no-repeat;
    }

    button.c-footer.write.on span.name {
      color: #407EDB;
      display: block;
    }
  }
`;


/* 기존 App / Guid 선택 전체 문서 부분 */
export const SubTabTableArea = styled.div`;

  @media screen and(min-width: 765px) and (max-width: 1199px) {
    .result-area {
      padding: 0 1.6rem;
    }
  }
`;

/*기술블로그용 검색 결과 없을 시 나오는 창*/
export const ErrorpageWrapBlog = styled.div`
  width: 100%;
  height: 100%;
  background: #EEF1F6;

  .Errorpage_blog {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 54rem;
    max-width: 120rem;
    background-color: #F7F8FB;
    width: 100%;
    margin: 0 auto;

    > .container {
      position: relative;
      width: 100%;
    }

    .error-image {
      //margin-top: -40rem;
    }

    .error-tit {
      font-size: 1.6rem;
      margin: 2rem 0px 0.4rem;
    }

    .error-txt {
      font-size: 1.4rem;
      color: #909FB7;
      ${fontFamilyRegular}
    }

    .error-button {
      display: inline-block;
      background: #407EDB;
      border-radius: 100px;
      width: 32rem;
      height: 4.8rem;
      line-height: 4.8rem;
      color: #fff;
      margin-top: 3.2rem;
      font-size: 1.6rem;
      ${fontFamilyBold};
      cursor: pointer;

      :hover {
        background: #3B71C4;
      }

      :active {
        background: #3463AB;
      }
    }

    .error-info {
      position: absolute;
      top: 50%;
      right: 6rem;
      transform: translateY(-50%);

      p {
        color: #407EDB;
        font-size: 1.2rem;
      }
    }
  }

  @media screen and (max-width: 764px) {

  }

  @media screen and (max-width: 1199px) {
    .error-info {
      display: none;
    }
  }
`;
